const isIntuitive = (organizationName?: string) => (
  organizationName?.toLowerCase() === "intuitive"
);

export default isIntuitive;
